import { Injectable } from '@angular/core';

import { CamBaseGridService, CamGridGraphConfig } from '@camelot/core';
import { GraphEndpoint } from '@camelot/server';

import { PurchaseOrderGridRow } from './dto/purchase-order-grid-row';

const graphEndpoint: GraphEndpoint = {
  clientName: 'purchaseService',
  endpoint: 'purchase',
};

@Injectable({
  providedIn: 'root',
})
export class CamPurchaseOrderGridService extends CamBaseGridService<PurchaseOrderGridRow> {
  protected _graphEndpoint = graphEndpoint;

  protected _gridGraph: CamGridGraphConfig = {
    entity: 'PurchaseOrder',
    idArg: 'purchaseOrderId',
    rowFields: () =>
      [
        'id',
        'parentId',
        'index',
        'hasChildren',
        'hidden',
        'rowType',
        'rowPricingType',
        'description',
        'quantity',
        'unit',
        'unitCostPrice',
        'exclVatTotal',
        'itemId',
        'activityIds',
        'deliveryModes',
        'budgetLineId',
        'order',
        'compositionPath',
      ].join(' '),
  };

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: this._graphEndpoint });
  }
}
